import React, { useCallback, useEffect, useState } from 'react';
import { fetchAllEmailTemplates } from '../../database/fetch-email-template';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import CreateEmailTemplateModal from './create-email-temp-modal';
import { deleteEmailTemplate } from '../../database/set-email-template';

const gridStyle = { height: '80vh' };

const EmailTemplateTable = () => {
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [openEmailTemplateModal, setOpenEmailTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});

  useEffect(() => {
    fetchAllEmailTemplates((templates) => {
      setEmailTemplates(templates);
    });
  }, []);

  const handleMailTypeRender = ({ value }) => {
    const mailTypes = {
      rfq: 'RFQ Packet',
      rfq_review: 'RFQ Review',
      rfq_rq: 'VRFQ',
      pos_oq: 'VPO Confirmation Original',
      pos_mq: 'VPO Confirmation Modified',
      pos_co: 'POS Confirmation',
      pos_final: 'VPO Final',
      del_sh: 'Shipping/Delivery',
      del_in: 'Invoice',
      thank_you: 'Thankyou for PO',
    };
    return mailTypes[value] || value;
  };

  const onDeleteRenderer = ({ data }) => (
    <button
      type="button"
      onClick={() => deleteEmailTemplate(data.docId)}
      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
    >
      Delete
    </button>
  );

  // Safe sort function to handle null/undefined values
  const safeStringSort = (a, b, fieldName) => {
    const aVal = a?.[fieldName] == null ? '' : String(a[fieldName]);
    const bVal = b?.[fieldName] == null ? '' : String(b[fieldName]);
    return aVal.localeCompare(bVal);
  };

  const tableColumns = () => [
    {
      name: 'index',
      header: '#',
      minWidth: 50,
      render: ({ rowIndex }) => (
        <div style={{ textAlign: 'center' }}>{rowIndex + 1}</div>
      ),
    },
    {
      name: 'title',
      header: 'Title',
      minWidth: 250,
      sort: (a, b) => safeStringSort(a, b, 'title'),
    },
    {
      name: 'mailType',
      header: 'Mail Type',
      minWidth: 250,
      render: handleMailTypeRender,
      sort: (a, b) => safeStringSort(a, b, 'mailType'),
    },
    {
      name: 'delete',
      header: 'Delete',
      minWidth: 50,
      render: onDeleteRenderer,
    },
  ];

  const tableFilterValue = [
    { name: 'title', operator: 'contains', type: 'string', value: '' },
    { name: 'mailType', operator: 'contains', type: 'string', value: '' },
  ];

  const handleRowClick = useCallback(
    (props) => {
      const clickedData = props.data;
      const matchingTemplate = emailTemplates.find(
        (template) => template.emailTempId === clickedData.emailTempId
      );

      if (matchingTemplate) {
        setSelectedTemplate(matchingTemplate);
        setOpenEmailTemplateModal(true);
      } else {
        console.warn(
          'No matching template found in state for ID:',
          clickedData.emailTempId
        );
      }
    },
    [emailTemplates]
  );

  return (
    <>
      <ReactDataGrid
        style={gridStyle}
        idProperty="emailTempId"
        defaultFilterValue={tableFilterValue}
        columns={tableColumns()}
        dataSource={emailTemplates}
        emptyText="Loading…"
        pagination
        defaultLimit={10}
        rowHeight={60}
        onRowClick={handleRowClick}
        showCellBorders={'horizontal'}
        columnMenu={{ lockable: false }}
      />

      <CreateEmailTemplateModal
        openModal={openEmailTemplateModal}
        setOpenModal={setOpenEmailTemplateModal}
        selectedTemplate={selectedTemplate}
        setSelectedTemplate={setSelectedTemplate}
      />
    </>
  );
};

export default EmailTemplateTable;
